module.exports = __webpack_public_path__ + "img/message-remove.e7a162f6.svg";